import QueryString from "qs";
import { isLoggedIn, logout, getAndStoreToken } from "../auth";

const axios = require("axios");
export const WSInstance = axios.create({
    paramsSerializer: (params) => QueryString.stringify(params, { arrayFormat: "repeat" }),
});

WSInstance.interceptors.request.use(
    async (request) => {
        request.headers["x-auth-token"] = localStorage.getItem("token");
        return request;
    },
    (error) => {
        Promise.reject(error);
    }
);

WSInstance.interceptors.response.use(
    (response) => {
        //console.log("RESPONSE - SUCCESS - "+`${response.config.method.toUpperCase()} ${response.config.url}`);
        //console.log(response.data);
        return response;
    },
    async function (error) {
        //console.log("RESPONSE - ERROR - "+`${error.response.config.method.toUpperCase()} ${error.response.config.url}`);
        //console.log("RESPONSE - ERROR: ", error);

        const originalRequest = error.config;
        if (error.response) {
            if (error.response.status === 401) {
                try {
                    await getAndStoreToken();
                    return WSInstance.request(originalRequest);
                } catch (err) {
                    if (isLoggedIn()) {
                        logout();
                    }
                    throw err;
                }
            } else {
                throw error.response;
            }
        }
        return Promise.reject(error);
    }
);
